import { render } from "./ScheduleProgramSessionsCard.vue?vue&type=template&id=8b7995b8"
import script from "./ScheduleProgramSessionsCard.vue?vue&type=script&lang=js"
export * from "./ScheduleProgramSessionsCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__